import { Component, OnInit } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { PermissionStorageService } from 'src/app/authentication/storages/permission-storage.service';
import { AbsenceGroupService } from '../services/absence-group.service';

@Component({
    selector: 'app-absences',
    templateUrl: './absences.component.html',
    styleUrls: ['./absences.component.css'],
    standalone: false
})
export class AbsencesComponent implements OnInit {

  constructor(
    private permissionStorage: PermissionStorageService,
    private absenceGroupService: AbsenceGroupService
  ) { }

  // The "all absences" tab is open to everyone: its calendar shows every employee, and the backend
  // redacts type and title outside the viewer's reach. Only the list view inside it is restricted
  // to a supervisor function (at least one subordinate) or SearchAll (HR). Resolved by the backend,
  // which alone knows the hierarchy.
  canViewTeamList = false;

  // Reviewing an absence means signing it off, so the tab is pointless without SignEntry.
  canSignEntry = (this.permissionStorage.getPermissions() ?? [])
    .includes('Permissions.AbsenceGroups.SignEntry');

  // The "to review" tab is shown to users with a supervisor/HR function. reviewCount drives its badge.
  canReview = false;
  reviewCount = 0;

  // The tabstrip is rendered only once canReview is resolved, so all tabs are evaluated in a single
  // render pass — Kendo's TabStrip does not reliably pick up a tab added asynchronously via *ngIf.
  ready = false;

  ngOnInit(): void {
    // Both flags have to be resolved before the tabstrip renders - see the note on `ready`.
    // Without the signing right the review tab is out anyway, so that call is skipped.
    forkJoin({
      review: this.canSignEntry ? this.absenceGroupService.canReviewAbsenceGroups() : of(false),
      team: this.absenceGroupService.canViewTeamAbsences()
    }).subscribe({
      next: ({ review, team }) => {
        this.canReview = review;
        this.canViewTeamList = team;
        this.ready = true;
        if (review) {
          this.absenceGroupService.searchAbsenceGroupsForApproval({ pageNumber: 1, pageSize: 1 })
            .subscribe(result => this.reviewCount = result.totalCount);
        }
      },
      error: () => this.ready = true
    });
  }
}
